import axios from "./config-axios";
import {isStringEmpty} from "./utility";



export const MAX_CHARS_IN_TEXTAREA = 20000;




// DO NOT USE
export const fieldChangedHandler = (event, comp) => {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    comp.setState( {
        [name] : value
    } );
};


// DO NOT USE
export const fieldChangedHandlerWithValidationCallback = (event, comp, callback) => {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    comp.setState( {
        [name] : value
    }, callback);
};









/**
 * Sets the state of the changing form field.
 *
 * Uses the ID of the form field to set the state.
 */
export const fieldChangedHandlerById = (event, comp) => {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const propertyName = target.id;

    comp.setState( {
        [propertyName] : value
    } );
};


/**
 * Sets the state of the changing form field and then performa a callback once the state is set.
 *
 * Uses the ID of the form field to set the state.
 */
export const fieldChangedHandlerByIdWithValidationCallback = (event, comp, callback) => {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const propertyName = target.id;

    comp.setState( {
        [propertyName] : value
    }, callback);
};




// export const fieldChangedHandlerByName = (event, comp) => {
//
//     const target = event.target;
//     const value = target.type === 'checkbox' ? target.checked : target.value;
//     const propertyName = target.name;
//
//     comp.setState( {
//         [propertyName] : value
//     } );
// };
//
//



/**
 * Sets the state of the changing form field and then performa a callback once the state is set.
 *
 * Uses the "name" of the form field to set the state.
 *
 * NOTE: Try and not to use this one. Use fieldChangedHandlerByIdWithValidationCallback()
 *       This is often used with checkboxes since the form "name" field is used to store a
 *       single value between fields.
 */
export const fieldChangedHandlerByNameWithValidationCallback = (event, comp, callback) => {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const propertyName = target.name;

    comp.setState( {
        [propertyName] : value
    }, callback);
};




/**
 * CHECKED-2021
 *
 * Input text form fields should not be set to null.
 * If the value is null or undefined it should be set to "".
 */
export const cleanValueForTextField = (value) => {
    if(value===null || value === undefined){
        return ""
    }
    return value;
};


/**
 * CHECKED-2021
 *
 * Prevents a form from being submitted.
 */
export const preventDefaultFormSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
};




let statesArray = null;

export const getStates = () => {

    return new Promise((resolve, reject) => {

        if(statesArray===null){

            axios({
                url: '/api/public/forms/helpers/getStates',
                method: 'get'
            }).then(result => {

                statesArray = result.data;

                resolve(statesArray);
            }).catch(error=>{
                reject(error);
            });
        }
        else {
            resolve(statesArray);
        }
    });
};



let departmentArray = null;

export const getDepartments = () => {

    return new Promise((resolve, reject) => {

        if(departmentArray===null){

            axios({
                url: '/api/public/forms/helpers/get-departments',
                method: 'get'
            }).then(result => {

                departmentArray = result.data;

                resolve(departmentArray);
            }).catch(error=>{
                reject(error);
            });
        }
        else {
            resolve(departmentArray);
        }
    });
};




let countryArray = null;


export const getCountries = () => {

    return new Promise((resolve, reject) => {

        if(countryArray===null){

            axios({
                url: '/api/public/forms/helpers/getCountries',
                method: 'get'
            }).then(result => {

                countryArray = result.data;

                resolve(countryArray);

            }).catch(error=>{

                reject(error);

            });
        }
        else {
            resolve(countryArray);
        }
    });
};





//
// ** Form Field Validation Helpers **
//
// Note:
// The context should look like this.
//
// const context = {
//     firstErrorField:null,
//     invalidFields: []
// };
//


/**
 * CHECKED-2021
 *
 * Performs a validation based on the funcValidator evaluating true or false.
 */
export const genericValidator = (fieldName, fieldRef, context, data, funcValidator, value) => {

    let isValid=true;
    if( !funcValidator(value) ){
        // If it fails validation set it to null.
        isValid=false;
    }

    data[fieldName] = value;

    updateValidationContext(fieldName, fieldRef, context, isValid);
};


/**
 * CHECKED-2021
 *
 * Updates the validation context.
 */
export const updateValidationContext=(fieldName, fieldRef, context, isValid)=>{
    if( !isValid ){
        context.invalidFields[fieldName+"_validated"] = false;

        if(!context.firstErrorField){
            context.firstErrorField = fieldRef;
        }
    } else {
        context.invalidFields[fieldName+"_validated"] = true;
    }
};


/**
 * CHECKED-2021
 *
 * Validates a text field.
 * Valid if the the input text "value" exists.
 */
export const validateTextField = (fieldName, fieldRef, context, data, value) => {

    data[fieldName] = value;

    updateValidationContext(fieldName, fieldRef, context, value);
};



/**
 * CHECKED-2021
 *
 * Validates a simple value.
 * Valid if the the input "value" exists.
 */
export const validateField = (fieldName, fieldRef, context, data, value) => {

    data[fieldName] = value;

    updateValidationContext(fieldName, fieldRef, context, value);
};



export const validateDropDownField = (fieldName, fieldRef, context, data, value) => {

    data[fieldName] = value;

    const isValid = (!value || value===0 || value==="0");

    updateValidationContext(fieldName, fieldRef, context, !isValid );
};


/**
 * CHECKED-2021
 *
 * Validates a drop down box value.
 * It assumes a value of 0 is invalid. This is used for "Select..." option.
 */
export const validateDropDownField_NumericValue = (fieldName, fieldRef, context, data, value) => {

    let intValue = parseInt(value);

    if( isNaN(intValue) ){
        intValue=null;
    }

    data[fieldName] = intValue;

    updateValidationContext(fieldName, fieldRef, context, intValue );
};


/**
 * 2021-CHECKED
 *
 * Returns the input value from a drop down as an int.
 */
export const safeParseIntValue = (value, defaultValue) => {
    let intValue = parseInt(value);

    if( isNaN(intValue) ){
        return defaultValue;
    }

    return intValue;
};


/**
 * CHECKED-2021
 *
 * Validates the phone field.
 */
export const validatePhoneNum = (fieldName, fieldRef, context, data, value) => {

    const officePhoneCleaned = convertPhoneIntoComponents(value, true);

    if(officePhoneCleaned.valid){
        data[fieldName]=buildFromPhoneComponents(officePhoneCleaned);
    } else {
        data[fieldName]=null;
    }

    updateValidationContext(fieldName, fieldRef, context, !!data[fieldName]);
};





/**
 * CHECKED-2021
 *
 * Returns true if the lenght of the string is under the MAX_CHARS_IN_TEXTAREA limit.
 */
export const validateMaxTextLength = (text) => {

    // Ok if missing.
    if(!text) return true;

    return text.length < MAX_CHARS_IN_TEXTAREA;
};


/**
 * CHECKED-2021
 *
 * Validates password minimum requirements.
 */
export const validatePasswordRequirements = (password) => {

    if(!password){
        return false;
    }

    if(password.length>50){
        // Limit max size.
        return false;
    }

    //
    // Contains
    // * Uppercase
    // * Lowercase
    // * Number
    // * Special charatcer
    //
    const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/;

    return regExp.test(password);
};


/**
 * CHECKED-2021
 *
 * Validates email address.
 */
export const validateEmail = (email) => {
    //eslint-disable-next-line
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};


/**
 * CHECKED-2022-P26
 *
 * Validates email address as @abbvie.com.
 */
export const validateCompanyEmail = (email) => {

    if(!validateEmail(email)){
        return false;
    }

    return email.toLowerCase().endsWith("@abbvie.com")
};



/**
 * CHECKED-2021
 *
 * Validas a US/Canadian postal code format.
 */
export const validZip = (zip) => {

    if(!zip){
        return false;
    }

    // US Zip
    const reUS = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
    //
    // return zip.match(reUS);

    // CA Zip  
    const reCA = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/;

    return zip.match(reUS) || zip.match(reCA);
};





// console.log(fixPhoneFormat_1('1234567'))
// console.log(fixPhoneFormat_1('(123)-456-7890'))
// console.log(fixPhoneFormat_1('1-(234)-567-8901'))
// console.log(fixPhoneFormat_1('908-873-2000 ext 2000'))

export const fixPhoneFormat_1 = (phone, defaultValue) => {

    if( isStringEmpty(phone) ){
        return defaultValue;
    }

    let ph = phone.replace(/\D/g, "");

    if( isStringEmpty(ph) ){
        return defaultValue;
    }

    //console.log(phone);
    //console.log(ph);

    if(ph.length===7){
        // 873-2000
        return ph.substring(0,3)+"-"+ph.substring(3)
    } else if(ph.length===10){
        // 908-873-2000
        return "("+ph.substring(0,3)+")-"+ph.substring(3, 6)+"-"+ph.substring(6);
    } else if(ph.length===11){
        // 1-908-873-2000
        return ph.substring(0,1)+"-("+ph.substring(1, 4)+")-"+ph.substring(4,7)+"-"+ph.substring(7);
    }

    // Display As is
    return phone;

};


/**
 * CHECKED-2021
 *
 * Decomposes a phone number and validates it.
 *
 * console.log( convertPhoneIntoComponents("123") );
 * console.log( convertPhoneIntoComponents("1-234-567-8901") );
 * console.log( convertPhoneIntoComponents("123-456-7890") );
 * console.log( convertPhoneIntoComponents("(908)-873-2000") );
 */
export const convertPhoneIntoComponents = (phone, requireAreaCode) => {

    const result = {
        valid:true,
        countryCode:null,
        areaCode:null,
        prefix:null,
        lineNumber:null
    };

    if( isStringEmpty(phone) ){
        result.valid = false;
        return result;
    }

    let ph = phone.replace(/\D/g, "");

    if( isStringEmpty(ph) ){
        result.valid = false;
        return result;
    }


    if(ph.length===7){
        // 873-2000
        result.prefix=ph.substring(0,3);
        result.lineNumber=ph.substring(3);
    } else if(ph.length===10){
        // 908-873-2000
        result.areaCode=ph.substring(0,3);
        result.prefix=ph.substring(3, 6);
        result.lineNumber=ph.substring(6);
    } else if(ph.length===11){
        // 1-908-873-2000
        result.countryCode=ph.substring(0,1);
        result.areaCode=ph.substring(1, 4);
        result.prefix=ph.substring(4,7);
        result.lineNumber=ph.substring(7);
    } else {
        //
        // Invalid Format
        //
        result.valid=false;

        if(ph.charAt(0)==='1'){
            result.countryCode=ph.substring(0,1);
            result.areaCode=ph.substring(1, 4);
            result.prefix=ph.substring(4,7);
            result.lineNumber=ph.substring(7);
        } else {
            result.areaCode=ph.substring(0,3);
            result.prefix=ph.substring(3, 6);
            result.lineNumber=ph.substring(6);
        }
    }

    if(!result.prefix || !result.lineNumber){
        result.valid=false;
    }

    if(requireAreaCode && (!result.areaCode || result.areaCode.length!==3) ){
        result.valid=false;
    }

    return result;
};



/**
 * CHECKED-2021
 *
 * Returns a formatted phone number from the input decomposed components.
 * The input should be true: comps.valid===true
 */
export const buildFromPhoneComponents = (comps) => {
    let array = [];
    if(comps.countryCode){
        array.push(comps.countryCode);
    }

    if(comps.areaCode){
        array.push(comps.areaCode);
    }

    if(comps.prefix){
        array.push(comps.prefix);
    }

    if(comps.lineNumber){
        array.push(comps.lineNumber);
    }

    return array.join('-');
};



// export const validatePhone = (phone) => {
//     let ph = phone.replace(/\D/g, "");
//
//     if( isStringEmpty(ph) ){
//         return false;
//     }
//
//     if( ph.length===10 || ph.length===11 ){
//         return true;
//     }
//
//     return false;
// };


export const phoneFieldKeyDownHandler = (event) => {

    const key = event.key;
    if( key===" "
        || key==="-"
        || key==="("
        || key===")"
        || key === "Delete"
        || key === "Tab"
        || key === "Backspace"
        || key === "ArrowLeft"
        || key === "ArrowRight"){
        return;
    }

    const keyNum = parseInt(key);
    if(!isNaN(keyNum) && keyNum>=0 && keyNum<=9){
        return;
    }

    event.preventDefault();
};


/**
 * CHECKED-2021-P2
 *
 * Returns the "id" field of checked options (for drop downs).
 */
export const getCheckedOptionsFromArray = (filterArray) => {
    let idArray = [];
    if( filterArray ){
        filterArray.forEach(filter=>{
            if(filter.checked){
                idArray.push(filter.id)
            }
        })
    }

    return idArray;
};


/**
 * CHECKED-2021-P3
 *
 * Returns the "id" field of the first checked options (for drop downs).
 */
export const getFirstCheckedOptionFromArray = (filterArray, noOptionCheckedValue) => {

    if( filterArray ){
        const len = filterArray.length;
        for(let i=0; i<len; i++){
            const op = filterArray[i];
            if(op.checked){
                return op.id;
            }
        }
    }

    return noOptionCheckedValue;
};



/**
 * CHECKED-2022-P8
 *
 * Checks the input array for the selected id.
 * array = [] of ids (NOT objects with an id)
 */
export const isChecked = (array, id, defaultIfNoArray) => {
    let isChecked;
    if( array ){
        isChecked = array.includes(id);
    } else {
        isChecked=defaultIfNoArray;
    }

    return isChecked;
};